module.exports = __webpack_public_path__ + "img/40_38_057_270.1295e282.jpg";